import { computed } from 'vue';

import { useChrome } from '@/platform/routing/chrome';

export function useSidebar() {
  const chrome = useChrome();
  const isFullCanvas = computed(() => !chrome.value.sidebar);
  return { isFullCanvas };
}
